
//todo : this class cannot be a filter + update + create request => need different spring validation for each
export class CRMRequestUpdateDTO {

    adminId: number;
    memberId: number;
    categoryIds: number[];
    statusIds: number[];
    dateStart: Date;
    dateEnd: Date;
    title: string;
    solution: string;
    problemDesc: string;
    reminderStatus: number;
    categoryId: number;
    statusId: number;
    reminderDate: Date | null;
    commentId: number;
    partnerRfpId: number | null;
    // When true, also push this reminder to the operator's Google Workspace calendar (REBO-959).
    addToGoogleCalendar: boolean;

    constructor(data?: any) {
        this.adminId = data?.adminId ?? "";
        this.categoryIds = data?.categoryIds ?? [];
        this.statusIds = data?.statusIds ?? [];
        this.dateStart = data?.dateStart ?? "";
        this.dateEnd = data?.dateEnd ?? "";
        this.title = data?.title ?? "";
        this.solution = data?.solution ?? "";
        this.problemDesc = data?.problemDesc ?? "";
        this.reminderStatus = data?.reminderStatus ?? "";
        this.categoryId = data?.categoryId ?? "";
        this.statusId = data?.statusId ?? "";
        this.reminderDate = data?.reminderDate ?? "";
        this.commentId = data?.commentId ?? 0;
        this.memberId = data?.memberId ?? "";
        this.partnerRfpId = data?.partnerRfpId ?? null;
        this.addToGoogleCalendar = data?.addToGoogleCalendar ?? false;
    }
}